import { useCallback, useMemo } from "react"
import { Dropdown, DropdownProps } from "@mezo-org/passport"

import {
  selectWalletBalances,
  setOpenModal,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import { useWalletDisconnect } from "#/shared/hooks"
import { WalletBalances } from "#/shared/types"

const mapBalancesToDropdownAssets = <T extends (keyof WalletBalances)[]>(
  balances: WalletBalances,
  types: T,
): {
  type: Lowercase<T[number]>
  balance: bigint
}[] =>
  types.map((type) => ({
    type: type.toLowerCase() as Lowercase<T[number]>,
    balance: balances[type].balance,
  }))

type DashboardHeaderAccountProps = Omit<
  DropdownProps,
  "onSignIn" | "onSignOut" | "evmNativeAssets" | "matsnetAssets" | "overrides"
>

export default function DashboardHeaderAccount(
  props: DashboardHeaderAccountProps,
) {
  const dispatch = useDappDispatch()

  const handleSignInOnClick = useCallback(() => {
    dispatch(setOpenModal("onboarding"))
  }, [dispatch])

  const balances = useDappSelector(selectWalletBalances)

  const evmAssets = useMemo(
    () => mapBalancesToDropdownAssets(balances, ["tBTC", "WBTC"]),
    [balances],
  )

  const matsnetAssets = useMemo(
    () => mapBalancesToDropdownAssets(balances, ["mBTC", "MUSD"]),
    [balances],
  )

  const { disconnect } = useWalletDisconnect()

  return (
    <Dropdown
      overrides={{
        Body: {
          style: {
            zIndex: 100,
          },
        },
      }}
      onSignIn={handleSignInOnClick}
      onSignOut={disconnect}
      // TODO: Remove hooks below when implemented fetching on Passport end
      evmNativeAssets={evmAssets}
      matsnetAssets={matsnetAssets}
      {...props}
    />
  )
}
